module.exports = __webpack_public_path__ + "img/struktur-organisasi-2.b57cbc16.jpg";